<template>
  <div class="home">
    <div class="banner">
      <div class="content">
        <div class="title">
          <h1>欢迎来到优质房产公司</h1>
          <h2>我们为您提供理想的居住环境</h2>
        </div>
        <div class="search">
          <el-input placeholder="请输入关键词" v-model="input"> </el-input>
          <div class="img"><img src="@/assets/searchIcon.png" alt="" /></div>
        </div>
      </div>
    </div>
    <div class="box1">
      <div class="content">
        <h1>用BuyAbility找到你能负担得起的房子℠</h1>
        <div class="img-container">
          <div
            v-for="(img, index) in images"
            :key="index"
            class="img-item"
            :class="{ active: activeIndex === index }"
            @click="setActive(index)"
            :style="{ backgroundImage: `url(${img})` }"
          ></div>
        </div>
      </div>
    </div>
    <div class="box2">
      <div class="content">
        <h1>新闻和信息</h1>
        <div class="bottom">
          <div class="plate" v-for="(item, index) in plateItems" :key="index">
            <img :src="item.image" alt="" />
            <h1>{{ item.title }}</h1>
            <h2>{{ item.subtitle }}</h2>
            <div class="blue" @click="goToNews(item.id)">浏览房源</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      input: "",
      activeIndex: 0, // 默认第一张图片放大
      images: [
        require("../assets/BuyAbilityImg0.png"),
        require("../assets/BuyAbilityImg1.png"),
        require("../assets/BuyAbilityImg2.png"),
        require("../assets/BuyAbilityImg3.png"),
      ],
      plateItems: [
        {
          id: 0,
          image: require("../assets/plateImg0.png"),
          title: "移民项目",
          subtitle: "Immigration Program",
        },
        {
          id: 1,
          image: require("../assets/plateImg1.png"),
          title: "留学教育",
          subtitle: "Overseas Education",
        },
        {
          id: 2,
          image: require("../assets/plateImg2.png"),
          title: "境外生活",
          subtitle: "Life Abroad",
        },
        {
          id: 3,
          image: require("../assets/plateImg3.png"),
          title: "资讯百科",
          subtitle: "Knowledge Base",
        },
      ],
    };
  },
  methods: {
    setActive(index) {
      this.activeIndex = index;
    },
    goToNews(id) {
      let path = "";
      switch (id) {
        case 0:
          path = "/news/immigration";
          break;
        case 1:
          path = "/news/education";
          break;
        case 2:
          path = "/news/living";
          break;
        case 3:
          path = "/news/knowledge";
          break;
        default:
          console.error("Unknown id:", id);
          return;
      }
      // 使用 Vue Router 进行页面跳转
      this.$router.push({ path: path });
    },
  },
};
</script>

<style scoped lang="less">
.content {
  margin: 0 auto;
  width: 100%;
  max-width: 75rem;
}
@media (max-width: 576px) {
  .home {
    .banner {
      padding: 25px;
      padding-bottom: 35px;
      .content {
        padding: 0;
        .title {
          margin-bottom: 37px;
          h1 {
            font-family: MiSans, MiSans;
            font-weight: 700;
            font-size: 30px;
            color: #ffffff;
            margin-bottom: 10px;
            line-height: 40px;
          }
          h2 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
            line-height: 22px;
          }
        }
        .search {
          width: 325px;
          height: 50px;
          background: #ffffff;
          border-radius: 11px 11px 11px 11px;
          border: 1px solid #cdcdd2;
          ::v-deep .el-input__inner {
            width: 325px !important;
            height: 50px !important;
          }
          .img {
            top: 14px;
            right: 15px;
          }
        }
      }
    }
    .box1 {
      padding: 20px 15px 35px;
      .content {
        h1 {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #1c1d25;
          text-align: center;
          margin-bottom: 20px;
        }
        .img-container {
          width: 345px;
          display: grid;
          grid-template-columns: repeat(3, 1fr); /* 设置三列布局 */
          gap: 6px; /* 设置间距 */
          margin: 0 auto;
          .img-item {
            width: 100%; /* 让每张图片占据一列的宽度 */
            height: auto; /* 根据宽高比自动调整高度 */
            margin-right: 0;
            cursor: none;
            border-radius: 17px;
            background-size: cover;
            background-position: center;
            // display: inline-block;
            // width: calc(33.33% - 4px); /* 三个等宽元素，考虑间隙 */
            img {
              width: 100%;
            }
          }
          .img-item:first-child {
            grid-column: span 3;
            width: 345px;
            height: 180px;
            border-radius: 9px;
            img {
              width: 100%;
            }
          }
          .img-item:nth-child(n + 2) {
            /* 选择第二张及之后的图片 */
            width: 110px;
            height: 97px;
          }
        }
        // .img-container {
        //   display: grid;
        //   grid-template-columns: 1fr; /* 单列布局 */
        //   gap: 6px;

        //   .img-item:first-child {
        //     width: 100%; /* 占满容器宽度 */
        //     height: 180px;
        //     grid-column: 1; /* 占据第一列 */
        //     border-radius: 9px;
        //   }

        //   /* 剩余三个图片放在第二行 */
        //   .img-item:not(:first-child) {
        //     display: inline-block;
        //     width: calc(33.33% - 4px); /* 三个等宽元素，考虑间隙 */
        //     height: 97px;
        //     margin-right: 6px;
        //   }

        //   .img-item:last-child {
        //     margin-right: 0;
        //   }
        // }
      }
    }
    .box2 {
      padding: 20px 0 35px;
      .content {
        h1 {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #1c1d25;
          text-align: center;
          margin-bottom: 20px;
        }
        .bottom {
          flex-direction: column;
          .plate {
            margin: 0 auto;
            padding: 56px 0 69px;
            width: 345px !important;
            max-width: 345px;
            img {
              max-width: 9rem;
            }
            h1 {
              font-size: 29px;
              line-height: 40px;
            }
            h2 {
              font-size: 17px;
              line-height: 23px;
            }
            .blue {
              cursor: pointer;
              width: 172px;
              max-width: 10.75rem;
              height: 43px;
              background: #026af9;
              border-radius: 24px 24px 24px 24px;
              font-size: 19px;
              color: #ffffff;
              line-height: 43px;
              text-align: center;
              margin: 32px auto 0;
            }
          }
        }
      }
    }
  }
}
@media (min-width: 577px) {
}
.banner {
  width: 100%;
  background: url(../assets/banner.png) no-repeat center/cover;
  .content {
    display: flex;
    flex-direction: column;
    // justify-content: flex-start;
    align-items: flex-start;
    margin: 0 auto;
    width: 100%;
    max-width: 75rem;
    padding: 111px 0 87px;
  }
  .title {
    display: flex;
    flex-direction: column;
    margin-bottom: 48px;
    // justify-content: flex-start;
    // align-items: flex-start;
    h1 {
      font-family: MiSans, MiSans;
      font-weight: 700;
      font-size: 50px;
      color: #ffffff;
      line-height: 66px;
      text-align: left;
      margin-bottom: 10px;
    }
    h2 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #ffffff;
      line-height: 34px;
      text-align: left;
    }
  }
  .search {
    width: 506px;
    height: 76px;
    background: #ffffff;
    border-radius: 11px;
    border: 1px solid #cdcdd2;
    position: relative;
    display: flex;
    justify-content: space-between;
    .img {
      position: absolute;
      top: 27px;
      right: 27px;
      width: 21px;
      height: 22px;
      cursor: pointer;
      img {
        width: 21px;
        height: 22px;
      }
    }
    ::v-deep .el-input {
      display: block;
      width: 80%;
    }
    ::v-deep .el-input__inner {
      height: 73px;
      border-radius: 11px;
      border: none;
      padding: 0;
      padding-left: 20px;
    }
    ::v-deep .el-input__suffix {
      margin-right: 20px;
    }
    ::v-deep .el-input__inner::placeholder {
      font-family: Source Han Sans, Source Han Sans;
      font-weight: 400;
      font-size: 14px;
      color: #535363;
    }
    ::v-deep .el-input__suffix-inner {
      width: 21px !important;
      height: 22px !important;
    }
  }
}
.box1 {
  padding: 50px 0 70px;

  h1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 22px;
    color: #1c1d25;
    line-height: 31px;
    text-align: center;
    margin-bottom: 46px;
  }
  .img-container {
    display: flex;
    justify-content: center;
    // gap: 15px;

    .img-item {
      width: 246px;
      height: 217px;
      background-size: cover;
      background-position: center;
      cursor: pointer;
      transition: all 0.3s ease;
      border-radius: 21px;
      margin-right: 15px;
      &.active {
        width: 417px;
        // transform: scale(1.05);
      }

      &:hover:not(.active) {
        transform: scale(1.02);
      }
    }
    .img-item:last-child {
      margin-right: 0;
    }
  }
}
.box2 {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  background: #f7f7f7;
  padding: 50px 0 70px;
  box-sizing: border-box;
  h1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 22px;
    color: #1c1d25;
    text-align: center;
    margin-bottom: 46px;
  }
  .bottom {
    display: flex;
    gap: 15px;
  }
  .plate {
    width: 100%;
    max-width: 18rem;
    // height: 357px;
    background: #ffffff;
    border-radius: 20px;
    border: 1px solid #cdcdd2;
    padding: 47px 0 58px;
    box-sizing: border-box;
    img {
      max-width: 7.5rem;
      // height: 120px;
      margin-bottom: 5px;
    }
    h1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #3d3d3d;
      line-height: 34px;
      text-align: center;
      margin-bottom: 10px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    h2 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 300;
      font-size: 14px;
      color: #3d3d3d;
      line-height: 20px;
      text-align: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .blue {
      cursor: pointer;
      margin: 27px auto 0;
      width: 80%;
      max-width: 9rem;
      height: 36px;
      background: #026af9;
      border-radius: 21px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      line-height: 36px;
      text-align: center;
    }
  }
}
</style>
